/** Data page helpers: the edit fingerprint and the catalogue query (DataPages.tsx draws the UI). */
import { useQuery } from '@tanstack/react-query';
import { coworkApi } from '@/cowork/omniad/api/coworkApi';

type Slide = Record<string, unknown>;
/** What a page holds, as a short fingerprint: Refresh asks first when it differs from what was built. */
export function pageSig(slide: Slide | undefined): string {
  const s = JSON.stringify((slide as { elements?: unknown })?.elements || []);
  let h = 0; for (let i = 0; i < s.length; i++) h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  return String(h);
}
/** A built page as it goes into the deck: its fingerprint kept, so later hand edits can be told apart. */
export const withSig = (slide: Slide): Slide => ({ ...slide, _data: { ...(slide._data as object), sig: pageSig(slide) } });

export function useDataPages() {
  return useQuery({ queryKey: ['cowork', 'data-pages'], queryFn: () => coworkApi.presentations.dataPages(), staleTime: 10 * 60_000 });
}

